import {
    ARRIVAL_TYPE,
    DEPARTURE_TYPE,
} from '../../../constants';
import {
    ALLOW_NEARBY_IS_ACTIVE_DEFAULT,
    DIRECT_ONLY_IS_ACTIVE_DEFAULT,
    TIMING_DEFAULT,
    DEFAULT_SORT,
} from '../constants';
import * as types from '../types';
const INITIAL_SUBSTATE = {
    allowNearby: ALLOW_NEARBY_IS_ACTIVE_DEFAULT,
    carriers: {},
    directOnly: DIRECT_ONLY_IS_ACTIVE_DEFAULT,
    features: {},
    sortType: DEFAULT_SORT,
    stations: {
        [ARRIVAL_TYPE]: {},
        [DEPARTURE_TYPE]: {},
    },
    timing: {
        arrival: TIMING_DEFAULT,
        departure: TIMING_DEFAULT,
    },
    travelModes: {},
};

const INITIAL_STATE = {
    initialQueries: {
        ...INITIAL_SUBSTATE,
    },
};

function setNewFilterId(state, action) {
    const {
        filterId,
    } = action.meta;

    return {
        ...state,
        [filterId]: {
            ...state[filterId] || INITIAL_SUBSTATE,
        },
    };
}

function hideFlights(state, action) {
    const noFlightsAction = {
        ...action,
    };

    if (
        (
            !state[noFlightsAction.meta]
            || !state[noFlightsAction.meta].travelModes
            || state[noFlightsAction.meta].travelModes.flight
        )
        || (
            noFlightsAction.payload
            && noFlightsAction.payload.travelModes
            && Object.keys(noFlightsAction.payload.travelModes).length === 1
            && noFlightsAction.payload.travelModes.flight
        )
    ) {
        return noFlightsAction;
    }

    if (
        noFlightsAction.payload
        && noFlightsAction.payload.travelModes
        && noFlightsAction.payload.travelModes.flight
    ) {
        noFlightsAction.payload.travelModes.flight = false;
    }

    if (noFlightsAction.payload && noFlightsAction.payload.carriers) {
        Object.keys(noFlightsAction.payload.carriers).forEach((carrier) => {
            if (noFlightsAction.payload.carriers[carrier].flight) {
                noFlightsAction.payload.carriers[carrier].flight = false;
            }
        });
    }

    return noFlightsAction;
}

function setBulk(state, action) {
    const noFlightsAction = hideFlights(state, action);

    const {
        meta: filterId,
        payload: filterSet,
    } = noFlightsAction;

    return {
        ...state,
        [filterId]: {
            ...state[filterId] || INITIAL_SUBSTATE,
            ...filterSet,
        },
    };
}

export {
    INITIAL_STATE,
    INITIAL_SUBSTATE,
};

const general = {
    [types.SET_BULK]: setBulk,
    [types.SET_NEW_FILTER_ID]: setNewFilterId,
};

export default general;
